import { useEffect, useState } from 'react'

import { Dayjs, dayjsEn } from '@bemlo/date'

const MINUTE_MS = 60_000

export type FromNowProps = {
  date: Dayjs
  withoutSuffix?: boolean
}

/**
 * A component that auto-updates `dayjs.fromNow()` every minute.
 */
export const FromNow = (props: FromNowProps) => {
  const [text, setText] = useState(props.date.fromNow(props.withoutSuffix))

  useEffect(() => {
    // If the date is at least 1 day old, don't auto-update:
    if (dayjsEn().diff(props.date, 'day') >= 1) return

    const interval = setInterval(() => {
      setText(props.date.fromNow(props.withoutSuffix))
    }, MINUTE_MS)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return <>{text}</>
}
